import React from 'react';
import { TrainingData } from './TrainingWizard';
import { Button } from '../ui/Button';
import { CheckCircleIcon, CalendarIcon, PlusIcon, ArrowRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface SuccessStepProps {
  trainingData: TrainingData;
}
export function SuccessStep({
  trainingData
}: SuccessStepProps) {
  const navigate = useNavigate();
  return <div className="text-center py-8" data-id="element-3337">
      <CheckCircleIcon className="h-16 w-16 text-green-500 mx-auto mb-4" data-id="element-3338" />
      <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-3339">
        Training Succesvol Ingepland!
      </h2>
      <p className="text-gray-600 mb-6 max-w-md mx-auto" data-id="element-3340">
        De training "{trainingData.trainingTypeName}" is succesvol ingepland
        voor{' '}
        {trainingData.startDate?.toLocaleDateString('nl-NL', {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      })}{' '}
        om{' '}
        {trainingData.startDate?.toLocaleTimeString('nl-NL', {
        hour: '2-digit',
        minute: '2-digit'
      })}
        .
      </p>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 max-w-md mx-auto mb-6" data-id="element-3341">
        <div className="text-left space-y-2" data-id="element-3342">
          <div className="flex justify-between" data-id="element-3343">
            <span className="text-gray-500" data-id="element-3344">Locatie:</span>
            <span className="font-medium" data-id="element-3345">{trainingData.locationName}</span>
          </div>
          <div className="flex justify-between" data-id="element-3346">
            <span className="text-gray-500" data-id="element-3347">Instructeur:</span>
            <span className="font-medium" data-id="element-3348">{trainingData.instructorName}</span>
          </div>
          <div className="flex justify-between" data-id="element-3349">
            <span className="text-gray-500" data-id="element-3350">Deelnemers:</span>
            <span className="font-medium" data-id="element-3351">
              {trainingData.participants.length}
            </span>
          </div>
          {trainingData.clientName && <div className="flex justify-between" data-id="element-3352">
              <span className="text-gray-500" data-id="element-3353">Klant:</span>
              <span className="font-medium" data-id="element-3354">{trainingData.clientName}</span>
            </div>}
        </div>
      </div>
      <div className="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-3" data-id="element-3355">
        <Button variant="outline" onClick={() => navigate('/planner')} data-id="element-3356">
          <CalendarIcon className="h-4 w-4 mr-1" data-id="element-3357" />
          Ga naar Planner
        </Button>
        <Button variant="outline" onClick={() => navigate('/training-wizard')} data-id="element-3358">
          <PlusIcon className="h-4 w-4 mr-1" data-id="element-3359" />
          Nieuwe Training
        </Button>
        <Button variant="primary" onClick={() => navigate('/dashboard')} data-id="element-3360">
          Dashboard
          <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-3361" />
        </Button>
      </div>
    </div>;
}